import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Table2Data } from '@uikit/Tables/types';

type LocationsSliceType = {
  locationLoginsData: Table2Data;
  shouldSupervisorApprove: boolean;
  openAuthModal: boolean;
  rideLocationData: any;
};

const initialState: LocationsSliceType = {
  locationLoginsData: {
    titles: [
      {
        id: '1',
        title: 'IP Address',
        fieldName: 'ip_address',
        type: 'string',
      },
      {
        id: '2',
        title: 'Location',
        fieldName: 'location',
        type: 'string',
      },
      {
        id: '3',
        title: 'Logged In At',
        fieldName: 'loggedInAt',
        type: 'string',
      },
      {
        id: '4',
        title: 'User',
        fieldName: 'user',
        type: 'string',
      },
    ],
    rows: [
      {
        id: '1',
        ip_address: '32.132.132.1',
        location: 'Pomona, California USA',
        loggedInAt: '05/15/2024 05:00 PDT',
        user: 'Michael L. (lujanom)',
      },
      {
        id: '2',
        ip_address: '27.127.127.0',
        location: 'Los angeles, California, USA',
        loggedInAt: '05/15/2024 05:00 PDT',
        user: 'George G. (glassg)',
      },
      {
        id: '3',
        ip_address: '32.132.132.1',
        location: 'Pomona, California USA',
        loggedInAt: '05/13/2024 13:01 PDT',
        user: 'Marvin T. (marvint)',
      },
    ],
  },
  shouldSupervisorApprove: false,
  openAuthModal: false,
  rideLocationData: null,
};

export const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    setSupervisorApprove(state, action: PayloadAction<boolean>) {
      state.shouldSupervisorApprove = action.payload;
    },
    setOpenAuthModal(state, action: PayloadAction<boolean>) {
      state.openAuthModal = action.payload;
    },
    setRideLocationData(state, action: PayloadAction<any>) {
      state.rideLocationData = action.payload;
    },
  },
});

export const selectLocations = (state: { locations: LocationsSliceType }) =>
  state.locations;

export const { setSupervisorApprove, setOpenAuthModal, setRideLocationData } =
  locationsSlice.actions;
export const locationsReducer = locationsSlice.reducer;
